interface BreakdownBarProps {
  passed: number;
  warning: number;
  failed: number;
  isEmpty?: boolean;
}

export function BreakdownBar({
  passed,
  warning,
  failed,
  isEmpty = false,
}: BreakdownBarProps) {
  if (isEmpty) {
    return (
      <div
        className="rounded overflow-hidden bg-secondary bg-opacity-25"
        style={{ height: 10 }}
      >
        <div
          className="h-100 bg-secondary bg-opacity-50 w-100"
        />
      </div>
    );
  }
  const total = passed + warning + failed;
  const minFlex = total * 0.03; // ensure small segments are at least 3% wide
  return (
    <div className="rounded overflow-hidden d-flex" style={{ height: 10 }}>
      {passed > 0 && <div className="bg-success" style={{ flex: Math.max(passed, minFlex) }} />}
      {warning > 0 && <div className="bg-warning" style={{ flex: Math.max(warning, minFlex) }} />}
      {failed > 0 && <div className="bg-danger" style={{ flex: Math.max(failed, minFlex) }} />}
    </div>
  );
}
